import React, { Component } from "react";
import { AiOutlineCloseCircle } from "react-icons/ai";
import ProfileService from "../../../api/ProfileService";
import AuthService from "../../../session/AuthService";
import { toast } from "react-toastify";
import CameraAltIcon from "@material-ui/icons/CameraAlt";
import VideocamIcon from "@material-ui/icons/Videocam";
import "./groupPostDesign.css";
import DescriptionIcon from "@material-ui/icons/Description";
import { getMyGroupsByMembersandMessages } from "../../../redux/actions/subjectActions";
import { API_URL } from "../../../config/app-config";
import dummyimage from "../../../img/default_avatar.jpg";
import "../../css/mysocial.css";
import "../../css/mysocialprofile.css";
import "../../css/yuukkeTutoring.css";
import i18n from "../../../i18n";
import { withTranslation } from "react-i18next";
import "react-widgets/styles.css";
import Grid from "@material-ui/core/Grid";
import Swal from "sweetalert2";

import { connect } from "react-redux";
import {
  getDashboardList,
  getMyQuestionsList,
} from "../../../redux/actions/dashboardActions";
import { getAllSubjectList } from "../../../redux/actions/subjectActions";
import { getMyLibraryQuestionList } from "../../../redux/actions/MyLibraryQuestionActions";
import { getQuestionsList } from "../../../redux/actions/questionActions";
import moment from "moment";
import Utils from "../../../utils/Utils";
import MessagesFileOption from "./MessagesFileOption";
import {
  getSubjectQuestionsList,
  getOverallPostList,
} from "../../../redux/actions/SubjectquestionActions";
import PostService from "../../../api/PostService_old";
import SurveyUi from "../../Home/HomeUpdated/SurveyUi";
import { getPostTagList } from "../../../redux/actions/commonApiActions";
import MentionsInputStyle from "../../../components/UserMention/Mention";
import { readOnlyWorkspace, removeMentionTags } from "../../../utils";
import AnonymousModel from "../../../components/AnonymousModel";
import ForumService from "../../../api/ForumService";

class MessagesContainerV2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileTypeKey: "",
      fileTypeState: false,
      blocking: false,
      fileUrl: null,
      type: null,
      mediaPost: "",
      isChecked: false,
      teaching: [],
      tags: [],
      question: "",
      classDetails: [],
      addTagsState: false,
      fileOption: false,
      gradeDetails: [],
      questionDescribed: "",
      content: "",
      editState: false,
      gradeId: "",
      questionTitleCount: 0,
      descriptionCount: 0,
      curriculumList: [],
      curriculumId: "",
      postCategory: "normal",
      posType: "",
      groupName: "",
      groupId: "",
      pollQuestion: "",
      inputs: [],
      frPollAnswer: [],
      SurveyQuestionandAns: [],
      currentValues: false,
      file: [],
      commentsEditText: "",
      needEdit: false,
      loader: false,
      anonymousPost: false,
      anonymousModel: false,
      showChildCommunitiesModal: false,
      childCommunities: [],
      selectedCommunityIds: [],
      showMembersModal: false,
      currentCommunity: null,
      communityMembers: {},
      selectedMembers: {},
      loadingMembers: false,
      totalSelectedMembers: 0
    };
    this.block = this.block.bind(this);
    this.myRef = React.createRef();
    this.getallSubject = this.getallSubject.bind(this);
    this.editorStateValues = this.editorStateValues.bind(this);
    this.handleTeachingMultiSelect = this.handleTeachingMultiSelect.bind(this);
    this.handleForm = this.handleForm.bind(this);
    this.toggleChange = this.toggleChange.bind(this);
    this.getQuestionMediaFiles = this.getQuestionMediaFiles.bind(this);
    this.handleGrade = this.handleGrade.bind(this);
    this.getallGrade = this.getallGrade.bind(this);
    this.fileOptionEnable = this.fileOptionEnable.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.getAllCurriculum = this.getAllCurriculum.bind(this);
    this.handleCurriculum = this.handleCurriculum.bind(this);
    this.getGradeByCurriculumId = this.getGradeByCurriculumId.bind(this);
    this.getGradeByCurriculumIdUpdate =
      this.getGradeByCurriculumIdUpdate.bind(this);
    this.keyFile = this.keyFile.bind(this);
    this.closeChoosedFileData = this.closeChoosedFileData.bind(this);
    this.handleFormEnterKey = this.handleFormEnterKey.bind(this);
    this.toggleChildCommunitiesModal = this.toggleChildCommunitiesModal.bind(this);
    this.fetchChildCommunities = this.fetchChildCommunities.bind(this);
    this.toggleCommunitySelection = this.toggleCommunitySelection.bind(this);
    this.toggleMembersModal = this.toggleMembersModal.bind(this);
    this.toggleMemberSelection = this.toggleMemberSelection.bind(this);
    this.toggleSelectAllMembers = this.toggleSelectAllMembers.bind(this);
    this.backToChildCommunities = this.backToChildCommunities.bind(this);
    this.calculateTotalSelectedMembers = this.calculateTotalSelectedMembers.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectedMembers !== this.state.selectedMembers) {
      this.calculateTotalSelectedMembers();
    }
  }

  calculateTotalSelectedMembers() {
    let total = 0;
    Object.values(this.state.selectedMembers).forEach(memberIds => {
      if (memberIds && Array.isArray(memberIds)) {
        total += memberIds.length;
      }
    });
    this.setState({ totalSelectedMembers: total });
  }

  toggleChildCommunitiesModal() {
    this.setState(prevState => ({
      showChildCommunitiesModal: !prevState.showChildCommunitiesModal,
      showMembersModal: false
    }), () => {
      if (this.state.showChildCommunitiesModal) {
        this.fetchChildCommunities();
      }
    });
  }

  backToChildCommunities() {
    this.setState({
      showChildCommunitiesModal: true,
      showMembersModal: false,
      currentCommunity: null
    });
  }

  async fetchChildCommunities() {
    try {
      const response = await ForumService.getAllChildCommunities({
        parentId: this.props.group_event_id
      });

      if (response.data.status === 1) {
        this.setState({
          childCommunities: response.data.data
        });
      } else {
        toast.error("Failed to load child communities");
      }
    } catch (error) {
      console.error("Error fetching child communities:", error);
      toast.error("Error fetching child communities");
    }
  }

  toggleCommunitySelection(communityId) {
    this.setState(prevState => {
      const currentSelected = prevState.selectedCommunityIds;
      if (currentSelected.includes(communityId)) {
        const newSelectedMembers = { ...prevState.selectedMembers };
        delete newSelectedMembers[communityId];

        return {
          selectedCommunityIds: currentSelected.filter(id => id !== communityId),
          selectedMembers: newSelectedMembers
        };
      } else {
        return {
          selectedCommunityIds: [...currentSelected, communityId]
        };
      }
    });
  }

  toggleMembersModal(community) {
    this.setState(prevState => ({
      showMembersModal: !prevState.showMembersModal,
      showChildCommunitiesModal: prevState.showMembersModal ? prevState.showChildCommunitiesModal : false,
      currentCommunity: community
    }), () => {
      if (this.state.showMembersModal) {
        this.fetchCommunityMembers(community.childId);
      }
    });
  }

  async fetchCommunityMembers(communityId) {
    this.setState({ loadingMembers: true });

    try {
      const response = await ForumService.getCommunityMembers({
        subjectId: communityId
      });

      if (response.data.status === 1) {
        const validMembers = response.data.data.filter(member => member.memberId != null);

        this.setState(prevState => ({
          communityMembers: {
            ...prevState.communityMembers,
            [communityId]: validMembers
          },
          loadingMembers: false
        }));
      } else {
        toast.error("Failed to load community members");
        this.setState({ loadingMembers: false });
      }
    } catch (error) {
      console.error("Error fetching community members:", error);
      toast.error("Error fetching community members");
      this.setState({ loadingMembers: false });
    }
  }

  toggleMemberSelection(communityId, memberId) {
    if (memberId == null) return;

    this.setState(prevState => {
      const selected = { ...prevState.selectedMembers };

      if (!selected[communityId]) {
        selected[communityId] = [];
      }

      if (selected[communityId].includes(memberId)) {
        return {
          selectedMembers: {
            ...selected,
            [communityId]: selected[communityId].filter(id => id !== memberId)
          }
        };
      } else {
        return {
          selectedMembers: {
            ...selected,
            [communityId]: [...selected[communityId], memberId]
          }
        };
      }
    });
  }

  toggleSelectAllMembers(communityId) {
    this.setState(prevState => {
      const members = prevState.communityMembers[communityId] || [];
      const selected = prevState.selectedMembers[communityId] || [];
      const allSelected = members.length > 0 && members.length === selected.length;

      if (allSelected) {
        return {
          selectedMembers: {
            ...prevState.selectedMembers,
            [communityId]: []
          }
        };
      } else {
        const validMemberIds = members
          .filter(member => member.memberId != null)
          .map(member => member.memberId);

        return {
          selectedMembers: {
            ...prevState.selectedMembers,
            [communityId]: validMemberIds
          }
        };
      }
    });
  }

  componentDidMount() {
    let langValue = AuthService.getCommonLanguages();
    i18n.changeLanguage(langValue);
    this.getGroupMemberList();
  }

  render() {
    const { t } = this.props;
    const { postCategory, totalSelectedMembers } = this.state;
    return (
      <div className="">
        <div className="groupPost-card groupPost-card-body">
          <div className="groupPost-d-flex groupPost-mb-3">
            <div className="groupPost-avatar groupPost-avatar-xs groupPost-me-2">
              <a href="#">
                <img
                  className="groupPost-avatar-img groupPost-rounded-circle"
                  src={
                    API_URL +
                    "api/getUserPhoto/" +
                    this.props.loginDetails.uId +
                    "/" +
                    this.props.loginDetails.dName
                  }
                  alt="user"
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = dummyimage;
                  }}
                />
              </a>
            </div>
            <form className="groupPost-w-100">
              {postCategory === "polling" && (
                <div className="Polling" style={{ marginTop: "2rem" }}>
                  <div className="PTCInputWrapper">
                    <Grid container>
                      <Grid className="gridform" item xs={12} sm={12}>
                        <textarea
                          style={{
                            width: "100%",
                            minHeight: "38px",
                            borderRadius: "5px",
                            padding: "20px 20px",
                            background: "#dceaee",
                            border: "none",
                          }}
                          type="text"
                          onChange={this.handleForm}
                          required=""
                          name="pollQuestion"
                          value={this.state.pollQuestion}
                          placeholder="Send Message"
                        />
                      </Grid>
                      {this.state.inputs.length > 0 &&
                        this.state.inputs.map((entry, index) => (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              paddingBlock: "1rem",
                              width: "100%",
                            }}
                          >
                            <span className="socialCardTextColor">
                              Option - {index + 1}
                            </span>
                            <Grid container spacing={2}>
                              <Grid className="gridform" item xs={12} sm={11}>
                                <input
                                  className="cpollInput"
                                  fullWidth
                                  type="text"
                                  onChange={(e) =>
                                    this.handleInputPollAnswer(e, index, "name")
                                  }
                                  style={{
                                    width: "100%",
                                    height: "4rem",
                                    border: "none",
                                    backgroundColor: "lightgray",
                                    padding: "20px",
                                  }}
                                  required=""
                                  name="frPollAnswer"
                                  placeholder="Add your option"
                                  value={
                                    this.state.frPollAnswer &&
                                    this.state.frPollAnswer[index] &&
                                    this.state.frPollAnswer[index].Sname
                                  }
                                />
                              </Grid>
                              <Grid className="gridform" item xs={12} sm={1}>
                                <span
                                  style={{
                                    display: "block",
                                    cursor: "pointer",
                                    fontSize: "35px",
                                  }}
                                  className="socialCardTextColor"
                                  onClick={() =>
                                    this.removeTranslation(entry, index)
                                  }
                                >
                                  -
                                </span>
                              </Grid>
                            </Grid>
                          </div>
                        ))}
                      <span
                        style={{
                          cursor: "pointer",
                          marginTop: "20px",
                          paddingBottom: "20px",
                        }}
                        className="socialCardTextColor"
                        onClick={this.addTranslation}
                      >
                        + Add more Option
                      </span>
                    </Grid>
                    <div
                      onClick={() =>
                        this.anonymousModel(!this.state.anonymousPost, true)
                      }
                      className="d-flex flex-wrap align-items-center mb-3"
                      style={{ cursor: "pointer" }}
                    >
                      <div className="boxcolor mr-1 event-box">
                        <input
                          type="checkbox"
                          value={this.state.anonymousPost}
                          checked={this.state.anonymousPost}
                          defaultChecked={this.state.anonymousPost}
                          id="anonymousPost"
                        />
                      </div>
                      <p
                        style={{ fontSize: "12px" }}
                        className="font-weight-bold"
                      >
                        Do you want this polling as anonymous?
                      </p>
                    </div>
                    {this.state.anonymousPost && this.state.anonymousModel && (
                      <AnonymousModel closeModel={this.anonymousModel} />
                    )}
                  </div>
                </div>
              )}
              {postCategory === "survey" && (
                <SurveyUi
                  surveyQuestion={this.SurveyQuestionandAns}
                  DataClear={this.state.surveyDataClear}
                />
              )}
              {(this.state.postCategory == "normal" ||
                this.state.postCategory == "advertisement") && (
                  <MentionsInputStyle
                    placeholder={"Send a message"}
                    editorStateValue={this.commentEditValues}
                    friendList={this.props.friendsList}
                    type={"group"}
                    needEdit={this.state.needEdit}
                    changeNeedHelpState={this.changeNeedHelpState}
                    editorValue={""}
                    isGroup={true}
                  />
                )}
            </form>
          </div>
          {!this.state.fileTypeState && (
            <ul
              style={{ marginBottom: "12px" }}
              className="groupPost-nav groupPost-nav-pills groupPost-nav-stack groupPost-small groupPost-fw-normal"
            >
              {postCategory !== "survey" && postCategory !== "polling" && (
                <li
                  className="groupPost-nav-item"
                  onClick={() => this.keyFile("image")}
                >
                  <a
                    className="groupPost-nav-link bg-light"
                    href="#!"
                    data-bs-toggle="modal"
                    style={{ cursor: "pointer" }}
                    data-bs-target="#feedActionPhoto"
                  >
                    <CameraAltIcon style={{ color: "#0cbc87" }} />
                    Photo
                  </a>
                </li>
              )}
              {postCategory !== "advertisement" &&
                postCategory !== "survey" &&
                postCategory !== "polling" && (
                  <>
                    <li
                      className="groupPost-nav-item"
                      onClick={() => this.keyFile("video")}
                    >
                      <a
                        className="groupPost-nav-link bg-light"
                        href="#!"
                        data-bs-toggle="modal"
                        style={{ cursor: "pointer" }}
                        data-bs-target="#feedActionVideo"
                      >
                        <VideocamIcon style={{ color: "#4f9ef8" }} />
                        Video
                      </a>
                    </li>
                    <li
                      className="groupPost-nav-item"
                      onClick={() => this.keyFile("audio")}
                    >
                      <a
                        href="#"
                        className="groupPost-nav-link bg-light"
                        data-bs-toggle="modal"
                        style={{ cursor: "pointer" }}
                        data-bs-target="#modalCreateEvents"
                      >
                        <DescriptionIcon style={{ color: "#dc3545" }} />
                        File
                      </a>
                    </li>
                  </>
                )}
              <li className="groupPost-nav-item">
                <div
                  className="groupPost-nav-link bg-light"
                  data-bs-toggle="modal"
                  style={{ cursor: "pointer" }}
                  data-bs-target="#modalCreateEvents"
                >
                  <select
                    name="postCategory"
                    style={{
                      border: "none",
                      backgroundColor: "#f8f9fa",
                      cursor: "pointer",
                    }}
                    id="postCategory"
                    onChange={this.handlepostingType}
                  >
                    <option value="normal">Normal Post</option>
                    <option value="advertisement">Advertisement</option>
                    <option value="polling">Polling Post</option>
                    <option value="survey">Survey Post</option>
                  </select>
                </div>
              </li>
              {this.props.isSupCom && (
                <button
                  className="btn btn-outline-primary mb-2"
                  onClick={this.toggleChildCommunitiesModal}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "8px 15px",
                    borderRadius: "6px",
                    border: "1px solid rgb(255, 255, 255)",
                    backgroundColor: "transparent",
                    color: "#ffffff",
                    transition: "all 0.3s",
                    marginLeft: "10px",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#3f51b5";
                    e.currentTarget.style.color = "white";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.color = "#ffffff";
                  }}
                >
                  <i className="bi bi-send"></i>
                  Send to Child Communities
                  {this.state.selectedCommunityIds.length > 0 && (
                    <span className="badge bg-primary ms-2">
                      {this.state.selectedCommunityIds.length}
                    </span>
                  )}
                  {totalSelectedMembers > 0 && (
                    <span className="badge bg-success ms-1">
                      {totalSelectedMembers} members
                    </span>
                  )}
                </button>
              )}
            </ul>
          )}
          {this.state.showChildCommunitiesModal && (
            <div className="child-communities-modal">
              <div className="modal-overlay" onClick={this.toggleChildCommunitiesModal}></div>
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Send to Child Communities</h5>
                  <div className="selection-indicators">
                    {this.state.selectedCommunityIds.length > 0 && (
                      <span className="badge communities-count">
                        {this.state.selectedCommunityIds.length} communities
                      </span>
                    )}
                    {totalSelectedMembers > 0 && (
                      <span className="badge members-count">
                        {totalSelectedMembers} members
                      </span>
                    )}
                  </div>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={this.toggleChildCommunitiesModal}
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  {this.state.childCommunities.length > 0 ? (
                    <div className="communities-grid">
                      {this.state.childCommunities.map(community => (
                        <div key={community.childId} className="community-card">
                          <div className="community-info">
                            <h6 className="community-name">{community.childName}</h6>
                            <span className="community-meta">
                              <i className="bi bi-people me-1"></i>
                              {community.totalMembers} members
                            </span>
                          </div>
                          <div className="community-actions">
                            <button
                              className="btn btn-members"
                              onClick={() => this.toggleMembersModal(community)}
                            >
                              <i className="bi bi-person-plus me-1"></i>
                              <span className="btn-text">Select Members</span>
                              {this.state.selectedMembers[community.childId]?.length > 0 && (
                                <span className="badge selected-count">
                                  {this.state.selectedMembers[community.childId]?.length}
                                </span>
                              )}
                            </button>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                checked={this.state.selectedCommunityIds.includes(community.childId)}
                                onChange={() => this.toggleCommunitySelection(community.childId)}
                              />
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="no-communities">
                      <div className="no-communities-icon">
                        <i className="bi bi-people"></i>
                      </div>
                      <h5>No child communities</h5>
                      <p className="text-muted">
                        This community doesn't have any child communities yet
                      </p>
                    </div>
                  )}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={this.toggleChildCommunitiesModal}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={this.toggleChildCommunitiesModal}
                  >
                    Confirm Selection
                  </button>
                </div>
              </div>
            </div>
          )}
          {this.state.showMembersModal && this.state.currentCommunity && (
            <div className="community-members-modal">
              <div className="modal-overlay" onClick={() => this.toggleMembersModal(null)}></div>
              <div className="modal-content">
                <div className="modal-header">
                  <div>
                    <h5 className="modal-title">Select Members</h5>
                    <p className="community-subtitle">
                      {this.state.currentCommunity.childName}
                    </p>
                  </div>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => this.toggleMembersModal(null)}
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  {this.state.loadingMembers ? (
                    <div className="loading-members">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p>Loading members...</p>
                    </div>
                  ) : (
                    <>
                      <div className="selection-controls">
                        <div className="form-check select-all">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked={
                              this.state.communityMembers[this.state.currentCommunity.childId]?.length > 0 &&
                              this.state.selectedMembers[this.state.currentCommunity.childId]?.length ===
                              this.state.communityMembers[this.state.currentCommunity.childId]?.length
                            }
                            onChange={() => this.toggleSelectAllMembers(this.state.currentCommunity.childId)}
                            id={`select-all-${this.state.currentCommunity.childId}`}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`select-all-${this.state.currentCommunity.childId}`}
                          >
                            Select All Members
                          </label>
                        </div>
                        <span className="selected-count">
                          {this.state.selectedMembers[this.state.currentCommunity.childId]?.length || 0} selected
                        </span>
                      </div>
                      <div className="members-list">
                        {this.state.communityMembers[this.state.currentCommunity.childId]?.map(member => (
                          <div key={member.memberId} className="member-card">
                            <div className="member-info">
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={
                                    this.state.selectedMembers[this.state.currentCommunity.childId]?.includes(member.memberId) || false
                                  }
                                  onChange={(e) => this.toggleMemberSelection(
                                    this.state.currentCommunity.childId,
                                    member.memberId
                                  )}
                                  id={`member-${member.memberId}`}
                                />
                              </div>
                              <div className="member-details">
                                <img
                                  src={API_URL + `api/getUserPhoto/${member.memberId}/${member.displayName}`}
                                  alt={member.displayName}
                                  className="member-avatar"
                                  onError={(e) => e.target.src = dummyimage}
                                />
                                <div className="member-text">
                                  <div className="member-name">{member.displayName}</div>
                                  <div className="member-username">@{member.userName}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-back"
                    onClick={this.backToChildCommunities}
                  >
                    <i className="bi bi-arrow-left me-1"></i> Back
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => this.toggleMembersModal(null)}
                  >
                    Save Selection
                  </button>
                </div>
              </div>
            </div>
          )}
          {this.state.fileTypeState && (
            <div>
              <AiOutlineCloseCircle
                onClick={this.closeChoosedFileData}
                style={{
                  cursor: "pointer",
                  paddingTop: "10px",
                  float: "right",
                  marginBottom: "8px",
                  width: "20px",
                  height: "20px",
                  color: "#000000",
                }}
              />
              <MessagesFileOption
                fileTypeKey={this.state.fileTypeKey}
                fileOption={this.state.fileOption}
                fileOptionEnable={this.fileOptionEnable}
                fromQuestionMedia={this.getQuestionMediaFiles}
                editObject={this.props.editObject}
              />
            </div>
          )}
          {!this.state.editState && (
            <div className="askAQuestionBtn">
              <center>
                <button
                  style={{ pointerEvents: this.state.loader ? "none" : "auto" }}
                  className="btn mb-0 connectionSumbitLabel"
                  onClick={(e) => this.onFormSubmit(e)}
                >
                  {this.state.loader ? (
                    <div className="spinner-border text-light" role="status"></div>
                  ) : (
                    <>{t("SUBMIT")}</>
                  )}
                </button>
              </center>
            </div>
          )}
        </div>
      </div>
    );
  }

  getGroupMemberList = () => {
    this.props.getPostTagList("groups", this.props.group_event_id);
  };

  changeNeedHelpState = () => {
    this.setState({
      needEdit: false,
    });
  };

  commentEditValues = (values) => {
    this.setState({
      content: values,
    });
  };

  SurveyQuestionandAns = (data) => {
    this.setState({
      SurveyQuestionandAns: data,
    });
  };

  handleInputPollAnswer(event, index, type) {
    event.preventDefault();
    event.stopPropagation();

    var newAnswers = [...this.state.frPollAnswer];
    if (newAnswers[index]) {
      if (type === "name") {
        newAnswers[index] = {
          ...newAnswers[index],
          Sname: event.target.value
        };
      } else {
        newAnswers[index] = {
          ...newAnswers[index],
          Scode: event.target.value
        };
      }
    } else {
      if (type === "name") {
        newAnswers[index] = {
          Sname: event.target.value,
          Scode: ""
        };
      } else {
        newAnswers[index] = {
          Sname: "",
          Scode: event.target.value
        };
      }
    }

    this.setState({
      frPollAnswer: newAnswers,
    });
  }

  addTranslation = (e) => {
    var len = this.state.inputs.length;
    if (
      this.state.frPollAnswer.length !== 0 &&
      this.state.frPollAnswer[len - 1] &&
      this.state.frPollAnswer[len - 1].Sname !== ""
    ) {
      var input = [...this.state.inputs];
      input.push(1);
      this.setState({
        inputs: input,
      });
    } else {
      toast.warning("Please fill option");
    }
  };

  removeTranslation = (record, index) => {
    if (this.state.inputs.length > 1) {
      var inpu = [...this.state.inputs];
      inpu.splice(index, 1);
      if (this.state.frPollAnswer[index]) {
        var val = [...this.state.frPollAnswer];
        val.splice(index, 1);
        this.setState({
          frPollAnswer: val,
        });
      }
      this.setState({
        inputs: inpu,
      });
    }
  };

  handlepostingType = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
      frPollAnswer: [],
      inputs: [1],
      pollQuestion: "",
    });
  };

  handleFormEnterKey(e) {
    if (this.state.content !== "") {
      if (e.keyCode === 13) {
        this.onFormSubmit(e);
      }
    }
  }

  closeChoosedFileData() {
    this.setState({ fileTypeState: false, file: [], postCategory: "normal" });
  }

  toggleChange = () => {
    this.setState({
      isChecked: !this.state.isChecked,
    });
  };

  handleGrade(event) {
    if (this.state.curriculumId === "") {
      Swal.fire({
        title: "Please choose valid program before choosing grade",
        icon: "warning",
        type: "warning",
        showCancelButton: false,
        confirmButtonText: "Ok",
        reverseButtons: true,
      }).then((result) => { });
    } else {
      this.setState({
        gradeId: event.target.value,
      });
    }
  }

  getQuestionMediaFiles(files, type) {
    this.setState({ file: files, type: type });
  }

  keyFile(key) {
    this.setState({ fileTypeKey: key, fileTypeState: true });
  }

  editorStateValues(values) {
    var htmlString = values;
    var plainString = htmlString.replace(/<[^>]+>/g, "");
    if (plainString.length === 1) {
      this.setState({
        content: values,
        plainStringContent: "",
        descriptionCount: 0,
      });
    } else {
      this.setState({
        content: values,
        plainStringContent: plainString,
        descriptionCount: plainString.length,
      });
    }
  }

  handleTeachingMultiSelect(subject_value) {
    this.setState({
      teaching: subject_value,
    });
  }

  getallSubject() {
    this.setState({ app_subjects: this.props.subjectsList.data });
  }

  getallGrade() {
    ProfileService.getAllGrades()
      .then((response) => {
        var result = response.data;
        this.setState({ gradeDetails: result.data.grade });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  fileOptionEnable() {
    this.setState({ fileOption: false, questionFile: null });
  }

  loaderState = () => {
    this.setState({
      loader: !this.state.loader,
    });
  };

  onFormSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    let validationSuccess = false;

    const formData = new FormData();
    if (
      !readOnlyWorkspace(
        this.props.userWorkSpace?.role,
        this.props.userWorkSpace?.typeHandle
      )
    ) {
      if (
        this.state.postCategory !== "survey" &&
        this.state.postCategory !== "polling" &&
        this.state.content === "" &&
        this.state.file &&
        this.state.file.length === 0
      ) {
        toast.warn("Please share something....");
      } else if (
        this.state.postCategory === "advertisement" &&
        (this.state.file.length === 0 ||
          this.state.file === null ||
          this.state.file === "")
      ) {
        toast.warn("Please choose image....");
      } else {
        this.loaderState();

        // Use a Set to avoid duplicates
        const allCommunityIds = new Set();

        // Add main community ID
        const mainCommunityId = parseInt(this.props.group_event_id, 10);
        allCommunityIds.add(mainCommunityId);

        // Add selected child community IDs
        this.state.selectedCommunityIds.forEach(id => {
          allCommunityIds.add(parseInt(id, 10));
        });

        // Prepare memberSelections
        const memberSelections = [];

        Object.entries(this.state.selectedMembers).forEach(([communityId, memberIds]) => {
          if (memberIds && memberIds.length > 0) {
            const validMemberIds = memberIds.filter(id => id != null);
            if (validMemberIds.length > 0) {
              const parsedCommunityId = parseInt(communityId, 10);

              // Add community ID from memberSelections to the subject list
              allCommunityIds.add(parsedCommunityId);

              memberSelections.push({
                communityId: parsedCommunityId,
                memberIds: validMemberIds
              });
            }
          }
        });

        // Append all unique subjectIds to formData
        for (const communityId of allCommunityIds) {
          formData.append("subjectIds", communityId);
        }

        // Optionally append memberSelections if needed
        formData.append("memberSelections", JSON.stringify(memberSelections));
        
        // Rest of form data
        if (
          this.state.postCategory === "normal" ||
          this.state.postCategory === "advertisement"
        ) {
          if (this.state.file !== undefined && this.state.file.length !== 0) {
            validationSuccess = true;
            formData.append("userName", this.props.loginDetails.dName);
            formData.append(
              "questionName",
              removeMentionTags(this.state.content)
            );
            formData.append("markAsPrivate", true);
            formData.append("Type", this.state.type);
            formData.append("tagDescription", this.props.group_event_name);
            formData.append("postCategory", this.state.postCategory);
            for (let i = 0; i < this.state.file.length; i++) {
              formData.append("messgaeFiles", this.state.file[i]);
            }
            formData.append("isGroup", true);
          } else {
            validationSuccess = true;
            formData.append("userName", this.props.loginDetails.dName);
            formData.append(
              "questionName",
              removeMentionTags(this.state.content)
            );
            formData.append("markAsPrivate", true);
            formData.append("Type", "text");
            formData.append("tagDescription", this.props.group_event_name);
            formData.append("postCategory", this.state.postCategory);
            formData.append("isGroup", true);
          }
        } else if (this.state.postCategory === "polling") {
          if (this.state.pollQuestion === "") {
            toast.warn("Please Add Questions");
          } else if (this.state.frPollAnswer.length === 0) {
            toast.warn("Please Add Answers");
          } else {
            validationSuccess = true;
            var filterAns = [];
            let array = this.state.frPollAnswer;
            array.forEach((element) => {
              filterAns.push(element.Sname);
            });

            formData.append("userName", this.props.loginDetails.dName);
            formData.append("markAsPrivate", true);
            formData.append("Type", "text");
            formData.append("tagDescription", this.props.group_event_name);
            formData.append("postCategory", this.state.postCategory);
            formData.append("postQuestion", this.state.posType);
            formData.append("postAnswers", filterAns);
            formData.append("isGroup", true);
            formData.append("isAnonymous", this.state.anonymousPost);
          }
        } else if (this.state.postCategory === "survey") {
          if (this.state.SurveyQuestionandAns.length === 0) {
            toast.warn("Please add your questions and answers");
          } else {
            if (this.state.SurveyQuestionandAns[0].answerType === "") {
              toast.warn("Please select your question type");
            } else if (
              this.state.SurveyQuestionandAns[0].answerType === "Text" &&
              this.state.SurveyQuestionandAns[0].textTypeAnswer === ""
            ) {
              toast.warn("Please fill answer");
            } else if (
              this.state.SurveyQuestionandAns[0].answerType === "Select" &&
              this.state.SurveyQuestionandAns[0].answers.length === 0
            ) {
              toast.warn("Please add your Answer");
            } else {
              validationSuccess = true;
              var arrayList = this.state.SurveyQuestionandAns;
              var final = [];

              arrayList.forEach((data) => {
                if (data.answerType === "Text") {
                  final.push({
                    question: data.question,
                    answer: data.textTypeAnswer,
                    answerType: data.answerType,
                  });
                } else {
                  final.push({
                    question: data.question,
                    answers: data.answers,
                    answerType: data.answerType,
                  });
                }
              });

              var obj = {
                questions: final,
              };
              const myJSON = JSON.stringify(obj);

              formData.append("userName", this.props.loginDetails.dName);
              formData.append(
                "questionName",
                removeMentionTags(this.state.content)
              );
              formData.append("markAsPrivate", true);
              formData.append("Type", "text");
              formData.append("tagDescription", this.props.group_event_name);
              formData.append("surveyQA", myJSON);
              formData.append("postCategory", this.state.postCategory);
              formData.append("isGroup", true);
            }
          }
        }
        if (validationSuccess) {
          const config = {
            headers: {
              "content-type": "multipart/form-data",
            },
          };

          PostService.createHomePostV2(formData, config)
            .then((response) => {
              this.setState({
                content: "",
                pollQuestion: "",
                inputs: [],
                frPollAnswer: [],
                postCategory: "normal",
                file: [],
                questionDescribed: "",
                fileTypeState: false,
                needEdit: true,
                selectedCommunityIds: [],
                selectedMembers: {},
                totalSelectedMembers: 0
              });
              this.props.getOverallPostList(
                this.props.pageNo,
                this.props.group_event_id
              );
              toast.success("Post saved successfully");
              this.loaderState();
            })
            .catch((error) => {
              console.log("Error details:", error.response?.data || error.message);
              this.setState({
                pollQuestion: "",
                inputs: [],
                frPollAnswer: [],
                postCategory: "normal",
                content: "",
                file: [],
                questionDescribed: "",
                fileTypeState: false,
              });
              toast.error("Error in saving post");
              this.loaderState();
            });
        } else {
          this.loaderState();
        }
      }
    }
  }

  block(blocking) {
    this.setState({ blocking: blocking });
  }

  handleForm(event) {
    this.setState({
      [event.target.name]: event.target.value,
      questionTitleCount: event.target.value.length,
    });
  }

  getAllCurriculum() {
    this.setState({
      curriculumList: this.props.curriculumtrackList.curriculum,
    });
  }

  handleCurriculum(event) {
    this.setState({
      curriculumId: event.target.value,
      gradeId: "",
    });
    this.getGradeByCurriculumId(event.target.value);
  }

  getGradeByCurriculumId(value) {
    this.setState({ gradeId: "" });
    let getGradeByCurriculumId = {
      curriculumId: value,
    };
    ProfileService.getGradeByCurriculumById(getGradeByCurriculumId)
      .then((response) => {
        var result = response.data;
        this.setState({ gradeDetails: response.data.data.gradeListById });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getGradeByCurriculumIdUpdate(value) {
    let getGradeByCurriculumId = {
      curriculumId: value,
    };

    ProfileService.getGradeByCurriculumById(getGradeByCurriculumId)
      .then((response) => {
        var result = response.data;
        this.setState({ gradeDetails: response.data.data.gradeListById });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  anonymousModel = (anonymousPost, anonymousModel) => {
    this.setState({
      anonymousPost: anonymousPost,
      anonymousModel: anonymousModel,
    });
  };
}

const mapStateToProps = function (state) {
  return {
    wallList: state.dashboard.dashboardList,
    loading: state.dashboard.loading,
    tagDatas: state.subjects.list,
    questionLists: state.myquestions.myQuestionList[0],
    totalItems: state.myquestions.myQuestionList[1],
    topQuestions: state.mylibraryquestion.list,
    solvedTotalitems: state.mylibraryquestion.totalItems,
    QandAquestionList: state.topquestList.list,
    QandAquestTotalitems: state.topquestList.totalItems,
    subjectsList: state.commonApi.subjectslist,
    loginDetails: state.loginDetailsApi.loginDetails,
    curriculumtrackList: state.commonApi.curriculumtracklist,
    friendsList: state.commonApi.tagUserList,
    userWorkSpace: state.loginDetailsApi.loginDetails?.userWorkSpace,
  };
};

const mapDispacthToProps = (dispatch) => {
  return {
    getOverallPostList: (pageNo, subId) =>
      dispatch(getOverallPostList(pageNo, subId)),
    getDashboardList: () => dispatch(getDashboardList(0)),
    getAllSubjectList: (type, page) => dispatch(getAllSubjectList(type, page)),
    getMyQuestionsList: () => dispatch(getMyQuestionsList(0)),
    getMyLibraryQuestionList: () =>
      dispatch(getMyLibraryQuestionList("All", 1)),
    getQuestionsList: () =>
      dispatch(getQuestionsList("unanswered", 1, 0, true, true)),
    getSubjectQuestionsList: (
      typeQuestionTop,
      tpage,
      subjectId,
      firstTimeLoad,
      secondTimeLoad,
      userId
    ) =>
      dispatch(
        getSubjectQuestionsList(
          typeQuestionTop,
          tpage,
          subjectId,
          firstTimeLoad,
          secondTimeLoad,
          userId
        )
      ),
    getMyGroupsByMembersandMessages: () =>
      dispatch(getMyGroupsByMembersandMessages()),
    getPostTagList: (type, id) => dispatch(getPostTagList(type, id)),
  };
};

export default connect(
  mapStateToProps,
  mapDispacthToProps
)(withTranslation()(MessagesContainerV2));